import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

function VehicleDetailsLightBoxContent(props) {
    const {
        data,
        onClose,
    } = props;

    return (
        <div className="cross-sell-light-box__content cross-sell-light-box-content">
            <p
                className="cross-sell-remove-light-box-content__why-alignment"
            >
                <Translation translationKey='vehicle-details-lightbox-content-prefix' />
                <Translation translationKey='vehicle-details-lightbox-content-text' />
            </p>

            <div className="cross-sell-remove-light-box-content__actions">
                <Translation
                    tagName="button"
                    className="cross-sell-remove-light-box-content__action-accept"
                    onClick={onClose}
                    translationKey="info-popup-body-button-text-vehicle-rego-ok-got-it"
                />
            </div>
        </div>
    );
}

VehicleDetailsLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { VehicleDetailsLightBoxContent };
